module.exports = __webpack_public_path__ + "img/5.ea3a753.png";